import * as type from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';
import Big from 'big.js';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const Laroute = require('../../laroute');

const state = {
    virtualShift: {
        id: null,
        name: null,
        cardList: [],
        cardSummary: [],
        cardType: [],
    },
};

const mutations = {
    [type.SET_VIRTUAL_SHIFT](state, virtualShift) {
        state.virtualShift = virtualShift;
    },
};

const getters = {
    virtualShift(state) {
        return state.virtualShift;
    },

    cardList() {
        return state.virtualShift.cardList;
    },

    cardType() {
        return state.virtualShift.cardType;
    },

    cardSummary() {
        return state.virtualShift.cardSummary;
    },

    totalCardList(state, getters) {
        const totalQuantity = getters.cardList
            .map(r => {
                return parseInt(r.quantity);
            })
            .reduce((a, b) => a + b, 0);

        const totalAmount = getters.cardList
            .map(r => {
                return parseFloat(r.amount_card_sales);
            })
            .reduce((a, b) => a + b, 0);

        return {
            total_quantity: totalQuantity,
            total_amount: totalAmount,
        };
    },

    totalCardType(state, getters) {
        const totalQuantity = getters.cardType
            .map(r => {
                return r.quantity;
            })
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        const totalAmount = getters.cardType
            .map(r => {
                return r.amount_card_sales;
            })
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        return {
            total_quantity: Big(totalQuantity).toString(),
            total_amount: Big(totalAmount).toFixed(2),
        };
    },

    totalCardSummary(state, getters) {
        const totalQuantity = getters.cardSummary
            .map(r => {
                return r.cardcount;
            })
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        const totalAmount = getters.cardSummary
            .map(r => {
                return r.subtotal;
            })
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        return {
            total_quantity: Big(totalQuantity).toString(),
            total_amount: Big(totalAmount).toFixed(2),
        };
    },
};

const actions = {
    getSales({ commit, dispatch }, params) {
        let route = Laroute.route('franchise.report.virtual_shift.sales');

        startLoading(dispatch, 'fetch-sales');

        return axios
            .get(route, {
                params: params,
            })
            .then(res => {
                endLoading(dispatch, 'fetch-sales');
                commit(type.SET_VIRTUAL_SHIFT, res.data);
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-sales');
                throw err;
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/virtual-shift.js